// components/sections/TaxInformation.tsx
import React from 'react';
import { Registry } from '@/graphql/__generated__/onboarding';
import { TaxRegimeCodes } from '@/utils/maps';
import TextSection from './TextSection';

interface TaxInformationProps {
	registry: Registry;
	onChangeRequest: (
		e: React.ChangeEvent<HTMLInputElement>,
		section: string,
		field: string,
		value: any
	) => void;
	changesRequested: Array<{ section: string; field: string; value: any }>;
	cantRequestChangesFromFields: string[];
}

export const TaxInformation: React.FC<TaxInformationProps> = ({
	registry,
	onChangeRequest,
	changesRequested,
	cantRequestChangesFromFields
}) => {
	return (
		<div className="space-y-3">
			<TextSection
				label="Rfc"
				value={registry.taxInformation?.rfc}
				field="Rfc"
				sectionName="TaxInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="Clabe"
				value={registry.taxInformation?.clabe}
				field="Clabe"
				sectionName="TaxInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="ClabeBankName"
				value={registry.taxInformation?.clabeBankName}
				field="ClabeBankName"
				sectionName="TaxInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="TaxRegimeCode"
				value={
					registry.taxInformation?.taxRegimeCode
						? TaxRegimeCodes[registry.taxInformation.taxRegimeCode]
						: null
				}
				field="TaxRegimeCode"
				sectionName="TaxInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="ESignatureSerialNumber"
				value={registry.taxInformation?.eSignatureSerialNumber}
				field="ESignatureSerialNumber"
				sectionName="TaxInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
		</div>
	);
};

export default TaxInformation;
